import { QueryState } from 'common/enums';
import { RequestData } from 'interfaces/request.interface';
import { IResponsesDB } from 'common/interfaces/response.interface';
import { INotifications } from 'interfaces/notification.interface';

export interface IRequestDetailState {
  loading: boolean;
  processing: boolean;
  serviceAction: QueryState;
  request: RequestData | null;
  responses: IResponsesDB[] | [];
  requests: INotifications[] | [];
  error: string | null | undefined;
}

export const RequestDetailEmptyState: IRequestDetailState = {
  loading: false,
  processing: false,
  serviceAction: QueryState.UNDEFINED,
  request: null,
  responses: [],
  requests: [],
  error: null,
};
